import { render } from "./VitrineWelcome.vue?vue&type=template&id=5d407ea4&scoped=true"
import script from "./VitrineWelcome.vue?vue&type=script&lang=js"
export * from "./VitrineWelcome.vue?vue&type=script&lang=js"

import "./VitrineWelcome.css?vue&type=style&index=0&id=5d407ea4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d407ea4"]])

export default __exports__